export default __webpack_public_path__ + "static/media/pbb.71daaab9.svg";